export default "__VITE_ASSET__D7kN$Cql__"